module.exports = __webpack_public_path__ + "img/vector.736fc27d.png";